import { Box, useTheme } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';
// import SwipeableViews from 'react-swipeable-views';
import { Swiper } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

interface IProps {
	children?: any;
}

export const CarouselComponent = ({ children }: IProps) => {
	const [activeStep, setActiveStep] = useState(0);
	const sliderRef = useRef(null);
	const [isStart, setIsStart] = useState(true);
	const [isEnd, setIsEnd] = useState(false);
	const handleNext = () => {
		if (!sliderRef.current) return;
		(sliderRef.current as any).swiper.slideNext();
	};
	const handlePrev = () => {
		if (!sliderRef.current) return;
		(sliderRef.current as any).swiper.slidePrev();
	};

	const onSlideChange = (swiper: any) => {
		setIsEnd(swiper.isEnd);
		setIsStart(swiper.isBeginning);
	};

	const showControls = useMemo(() => children?.length > 4, [children]);

	return (
		<>
			<Box
				sx={{
					maxWidth: '1058px',
					flexGrow: 1,
					position: 'relative',
				}}
			>
				<Swiper
					onSlideChange={onSlideChange}
					slidesPerView={4}
					slidesPerGroup={4}
					spaceBetween={'20px'}
					modules={[Navigation]}
					ref={sliderRef}
				>
					{children}
				</Swiper>
				{showControls && (
					<div style={{ position: 'absolute', left: '-70px', top: '50%', display: 'flex' }}>
						<div onClick={handlePrev} aria-disabled={isStart!}>
							<img
								src="/icons/arrow-left.svg"
								style={{
									cursor: isStart ? 'unset' : 'pointer',
									opacity: isStart ? 0.2 : 1,
									width: '30px',
									margin: 0,
									top: '50%',
									left: '7%',
									transform: 'translate(5%, -50%) rotate(-180deg)',
								}}
							/>
						</div>
						<div onClick={handleNext} aria-disabled={isEnd!}>
							<img
								src="/icons/arrow-left.svg"
								style={{
									cursor: isEnd ? 'unset' : 'pointer',
									opacity: isEnd ? 0.2 : 1,
									width: '30px',
									margin: 0,
									top: '50%',
									left: '5%',
									transform: 'translate(5%, -50%)',
								}}
							/>
						</div>
					</div>
				)}
			</Box>
		</>
	);
};
